import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { CustomerDashboardService } from "../../../services/customer-dashboard.service";
import { FormControl, Validators } from "@angular/forms";


@Component({
  selector: 'fury-agreement-actions-modal',
  templateUrl: './agreement-actions-modal.component.html',
  styleUrls: ['./agreement-actions-modal.component.scss']
})
export class AgreementActionsModalComponent implements OnInit {

  ngUnsubscribe = new Subject<void>();
  private searchSubject = new Subject<string>();
  agents = [];
  @ViewChild("picker") picker: any;
  @ViewChild("fileOpen") fileOpen: ElementRef;
  discountedPrice = 0;

  modalHeading = {
    updateWaitingPeriod: "Waiting Periods",
    updateCustomerScore: "Customer Score",
    updateContactInfo : "Contact Information",
    updateAgreementHolderDetail: "Agreement Holder",
    updateFreeMonth: "Free Month",
    sendEscrowConfirmationMail: "Send Escrow Confirmation Mail",
  };
  modalButtonText = {
    updateWaitingPeriod: "Update",
    updateCustomerScore: "Update Score",
    updateContactInfo : "Update",
    updateAgreementHolderDetail: "Update",
    sendEscrowConfirmationMail: "Send Mail",
    updateFreeMonth: "Update",
  };
  fileName = "";
  datePicker = {
    disabled: false,
    showSpinners: true,
    showSeconds: false,
    touchUi: false,
    enableMeridian: false,
    minDate: new Date().toISOString().split("T")[0],
    stepHour: 1,
    stepMinute: 1,
    stepSecond: 1,
    color: "primary",
  };
  customerScores = ["A+","A","A-","B+","B","B-","C+","C","C-","D","E","F"];
 
  constructor(
    public dialogRef: MatDialogRef<AgreementActionsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    public commonService: CommonService,
    private customerDashboardService: CustomerDashboardService,
  ) {}

  ngOnInit(): void {
    this.data?.formGroup?.reset();
    this.getData();
  }

  getData() {
    switch (this.data?.actionModal) {
      case "updateWaitingPeriod": {
        this.getAgreementInfo("updateWaitingPeriod");
        break;
      }
      case "updateCustomerScore": {
        this.getAgreementInfo("updateCustomerScore");
        break;
      }
      case "updateContactInfo": {
        this.getAgreementInfo("updateContactInfo");
        break;
      }
      case "updateAgreementHolderDetail": {
        this.getAgreementInfo("updateAgreementHolderDetail");
        break;
      }
      case "updateFreeMonth": {
        this.getAgreementInfo("updateFreeMonth");
        break;
      }
      default: {
        break;
      }
    }
  }
  handleDateOpen() {
    this.picker.open();
    setTimeout(() => {
      this.picker.value = this.data?.formGroup?.value?.value;
    }, 1500);
  }

  getAgreementInfo(actionTypes: string) {
    this.data?.formGroup?.reset();
    this.apiService
      .get(
        endpoints.customerDashboard.getAgreementDetailSectionWise(
          this.data?.agreementId,
          actionTypes
        )
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          switch(this.data?.actionModal){
            case "updateWaitingPeriod":{
              this.data.formGroup
              .get("waitingPeriod")
              .setValue(res?.body?.actionData);
              break;
            }
            case "updateCustomerScore":{
              this.data.formGroup
              .get("customerScore")
              .setValue(res?.body?.actionData);
              break;
            }
            case "updateContactInfo":{
              this.data.formGroup
              .patchValue(res?.body?.actionData);
              break;
            }
            case "updateAgreementHolderDetail":{
              this.data.formGroup
              .patchValue(res?.body?.actionData);
              break;
            }
             case "updateFreeMonth":{
              this.data.formGroup
              .patchValue({freeMonth: res?.body?.actionData});
              break;
            }
            
            default: {
              break;
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.apiService.alert(err.error.message, ErrorType.Error);
        }
      );
  }

  close() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.data?.formGroup?.invalid) {
      this.data?.formGroup?.markAllAsTouched();
      return;
    }
    this.dialogRef.close({ actionValue: this.data?.formGroup?.value });
  }

//  onFileUpload(event: any) {
//     if (
//       event.target.files[0].type === "image/jpeg" ||
//       event.target.files[0].type === "image/png" ||
//       event.target.files[0].type === "image/jpg" ||
//       event.target.files[0].type === "application/pdf"
//     ) {
//       this.data?.formGroup?.get("value").setValue(event.target.files[0]);
//       this.fileName = event.target.files[0]?.name;
//     } else {
//       this.apiService.alert(
//         "Please select an image or pdf file",
//         ErrorType.Error
//       );
//     }
//   }
 

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
